"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readDate = void 0;
const luxon_1 = require("luxon");
const types_1 = require("../types");
function readDate(dateStr, zone) {
    return luxon_1.DateTime.fromFormat(dateStr, types_1.ScheduleDateFormat, {
        zone,
    });
}
exports.readDate = readDate;
//# sourceMappingURL=readDate.js.map